import { z } from "zod";
import { dateSchema } from "./date-and-time";
import { visitSchema } from "./visits";

export const routeStatusSchema = z.enum(["draft", "ongoing", "finished"]);
export type IRouteStatus = z.infer<typeof routeStatusSchema>;

export const routeSchema = z.object({
  id: z.string(),
  finishedAt: dateSchema.nullish(),
  status: routeStatusSchema,
  visits: z.array(visitSchema),
  timespan: z
    .object({
      from: dateSchema,
      to: dateSchema,
    })
    .nullish(),
});
export type IRoute = z.infer<typeof routeSchema>;

export const routesSchema = z.array(routeSchema);

export const isRoute = <T extends object>(
  item: T,
): item is Extract<T, { visits: unknown }> => "visits" in item;
